export default function AdvantagesSection() {
  const advantages = [
    {
      icon: "ri-shield-check-line",
      title: "Expertise Reconnue",
      description: "Spécialistes des installations en serres agricoles depuis plus de 15 ans, nous maîtrisons parfaitement les enjeux de l'hygrométrie et du climat sous serre.",
      color: "#4F8B3A"
    },
    {
      icon: "ri-money-euro-circle-line",
      title: "Financement 100% CEE",
      description: "Grâce à la fiche AGRI-TH-117, bénéficiez d'une prise en charge totale de votre équipement et de son installation. Zéro euro à avancer si vous êtes éligible.",
      color: "#4F8B3A"
    },
    {
      icon: "ri-tools-line",
      title: "Installation Clé en Main",
      description: "De l'étude technique à la mise en service, nous gérons l'intégralité de votre projet. Installation certifiée RGE, dossier conforme, suivi complet.",
      color: "#4F8B3A"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Pourquoi Nous Choisir ?</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Une solution complète pour optimiser le climat de vos serres et protéger vos cultures
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {advantages.map((advantage, index) => (
            <div 
              key={index} 
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div 
                className="w-16 h-16 rounded-full flex items-center justify-center mb-6"
                style={{ backgroundColor: advantage.color }}
              >
                <i className={`${advantage.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{advantage.title}</h3>
              <p className="text-gray-600 leading-relaxed">{advantage.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
